module.exports = __webpack_public_path__ + "img/batchDropDown.6d0da5f0.svg";